import type { ReleaseInfoErrors } from './errors';
import type { ReleaseInfoFields, ReleaseInfoState, ReleaseInfoTouchedFields } from './schema';

export function releaseInfoInitialState() {
  return {
    errors: initialReleaseInfoErrors(),
    fields: initialReleaseInfoFields(),
    touched: initialReleaseInfoTouchedFields(),
    accordion: initialReleaseInfoAccordionState(),
    isValid: false,
  } satisfies ReleaseInfoState;
}

export function initialReleaseInfoAccordionState() {
  return {
    value: null,
  };
}

export function initialReleaseInfoTouchedFields() {
  return {
    title: false,
    tokenSymbol: false,
    track: false,
    coverImage: false,
    genre: false,
    behindTheMusic: false,
    staticCoverImage: false,
    beatsPerMinute: false,
    key: false,
    lyrics: false,
    license: false,
    location: false,
    canCollectorsDownloadAudio: false,
    curatorRewardsEnabled: false,
    rewards: [],
    editionCoverGa: false,
    editionCoverGoldenEgg: false,
  } satisfies ReleaseInfoTouchedFields;
}

export const releaseInfoDirtyFields = {
  title: true,
  tokenSymbol: true,
  track: true,
  coverImage: true,
  genre: true,
  behindTheMusic: true,
  staticCoverImage: true,
  beatsPerMinute: true,
  key: true,
  lyrics: true,
  license: true,
  location: true,
  canCollectorsDownloadAudio: true,
  curatorRewardsEnabled: true,
  rewards: [],
  editionCoverGa: true,
  editionCoverGoldenEgg: true,
} satisfies ReleaseInfoTouchedFields;

export function initialReleaseInfoFields() {
  return {
    title: null,
    tokenSymbol: null,
    track: null,
    coverImage: null,
    canCollectorsDownloadAudio: true,
    curatorRewardsEnabled: true,
    rewards: [],
    genre: null,
    behindTheMusic: null,
    staticCoverImage: null,
    beatsPerMinute: null,
    key: null,
    lyrics: null,
    license: null,
    location: null,
    editionCoverGa: null,
    editionCoverGoldenEgg: null,
  } satisfies ReleaseInfoFields;
}

export function initialReleaseInfoErrors() {
  return {
    title: null,
    tokenSymbol: null,
    track: null,
    coverImage: null,
    genre: null,
    behindTheMusic: null,
    staticCoverImage: null,
    beatsPerMinute: null,
    key: null,
    lyrics: null,
    license: null,
    location: null,
    canCollectorsDownloadAudio: null,
    curatorRewardsEnabled: null,
    rewards: [],
    editionCoverGa: null,
    editionCoverGoldenEgg: null,
  } satisfies ReleaseInfoErrors;
}
